import { Handshake } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card'
import { tourAnchor } from '~/helpers/tour/anchors'

/**
 * À la place du choix de palier, pour une organisation dont Studeva tient le
 * compte (#349) : il n'y a rien à choisir ni à régler ici. La note interne du
 * super-admin n'est jamais montrée.
 */
function ManagedPlanNotice() {
  const { t } = useTranslation()

  return (
    <Card {...tourAnchor('billing.plan')}>
      <CardHeader>
        <CardTitle>{t('billing.plan.title')}</CardTitle>
      </CardHeader>
      <CardContent className="flex items-start gap-3">
        <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-accent text-accent-foreground">
          <Handshake className="size-5" aria-hidden />
        </span>
        <div className="space-y-1">
          <p className="font-medium">{t('billing.managed.title')}</p>
          <p className="text-sm text-muted-foreground">{t('billing.managed.body')}</p>
        </div>
      </CardContent>
    </Card>
  )
}

export default ManagedPlanNotice
